import { Pipe, PipeTransform } from '@angular/core';
import { ProductStockViewModel } from '@models/api-search.models';
import { StoreViewModel } from '@models/api.models';

// Matches stores with stock from Product and stores from Umbraco. Only returns stores that exists in both places
@Pipe({
    name: 'storeMatches',
    standalone: true
})
export class StoreMatches implements PipeTransform {
    transform(storeStocks?: ProductStockViewModel[], stores?: StoreViewModel[] | null): ProductStockViewModel[] {
        if (!storeStocks?.length || !stores?.length) {
            return [];
        }
        // Combine stock data, and store data, so we only have the stores that both have store data and stock data.
        return storeStocks.filter(stockStore => stores.find(store => store.storeId?.toString() === stockStore.storeId));
    }
}
